(function () {
    'use strict';

    a3_cabin_reports.controller('JumpseatRequestsCtrl', JumpseatRequestsCtrl);

    /**
     * @memberof CabinReports
     * @ngdoc controller
     * @name JumpseatRequestsCtrl
     * @description
     *   Controller for Jumpseat Requests
     * @ngInject
     */
    function JumpseatRequestsCtrl($scope, JumpseatRequestsFactory, UserFactory) {
        
        // Set state for footer navigation
        $scope.state = 'jumpseatRequests';
        $scope.jumpseatInfo = null;
        $scope.currentUser = UserFactory.getUser();
        $scope.jumpseatRequestForm = {};
        $scope.isSubmittingJumpseatRequest = false;
        $scope.jumpseatRequestFormState = {
            isFlightDatePickerOpen: false
        };
        $scope.jumpseatFlightDateOptions = {};
        $scope.refreshJumpseatInfo = refreshJumpseatInfo;
        $scope.confirmCancelSubmittedRequest = confirmCancelSubmittedRequest;
        $scope.confirmAcceptAcknowledgeRequest = confirmAcceptAcknowledgeRequest;
        $scope.confirmRejectAcknowledgeRequest = confirmRejectAcknowledgeRequest;
        $scope.openJumpseatFlightDatePicker = openJumpseatFlightDatePicker;
        $scope.onJumpseatRequestTypeChanged = onJumpseatRequestTypeChanged;
        $scope.onJumpseatTravelersTypeChanged = onJumpseatTravelersTypeChanged;
        $scope.shouldShowTravelersSection = shouldShowTravelersSection;
        $scope.shouldShowEntitledPassengersSection = shouldShowEntitledPassengersSection;
        $scope.addEntitledPassenger = addEntitledPassenger;
        $scope.removeEntitledPassenger = removeEntitledPassenger;
        $scope.submitJumpseatRequest = submitJumpseatRequest;
        $scope.getJumpseatStatusLabel = getJumpseatStatusLabel;
        $scope.getJumpseatStatusBadgeClass = getJumpseatStatusBadgeClass;
        $scope.isGeneralDeclarationRequest = isGeneralDeclarationRequest;
        $scope.getSubmittedPassengerRows = getSubmittedPassengerRows;
        $scope.hasSubmittedPassengerRows = hasSubmittedPassengerRows;

        // Initialize on controller load
        init();

        
        /**
         * Initialize controller data loading.
         */
        function init() {
            refreshJumpseatInfo();
        }

        /**
         * Refresh jumpseat information from service.
         * Blocks execution when device is offline.
         */
        function refreshJumpseatInfo() {
            if (!window.navigator.onLine) {
                bootbox.alert({ title: "<div class='text-orange'>No Internet</div>", message: 'Please check the internet connection!' });
                return;
            }

            JumpseatRequestsFactory.getJumpseatInfo(function (responseData) {
                if (!responseData.success) {
                    bootbox.alert({
                        title: "<div class='text-red'>Error</div>",
                        message: responseData.errorMessage || 'Unable to load Jumpseat Requests information.'
                    });
                    return;
                }

                $scope.jumpseatInfo = responseData.data;
                initializeJumpseatRequestForm();
                prepareSubmittedRequestsViewModel();
            }, function () {
                bootbox.alert({ title: "<div class='text-red'>Error</div>", message: 'Unable to load Jumpseat Requests information.' });
            });
        }

        /**
         * Ask user confirmation before canceling a submitted request.
         * @param {number} requestId request identifier to cancel
         */
        function confirmCancelSubmittedRequest(requestId) {
            bootbox.dialog({
                message: '<strong>You are about to cancel this request. Are you sure?</strong><br/><br/>',
                title: 'Caution!',
                buttons: {
                    confirm: {
                        label: 'Confirm',
                        className: 'btn-danger',
                        callback: function () {
                            runActionRequest('cancel', requestId, 'Request canceled successfully.');
                        }
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-default',
                        callback: function () { }
                    }
                }
            });
        }

        /**
         * Ask user confirmation before accepting an acknowledge request.
         * @param {number} requestId request identifier to accept
         */
        function confirmAcceptAcknowledgeRequest(requestId) {
            bootbox.dialog({
                message: '<strong>You are about to accept this request. Are you sure?</strong><br/><br/>',
                title: 'Caution!',
                buttons: {
                    confirm: {
                        label: 'Confirm',
                        className: 'btn-green',
                        callback: function () {
                            runActionRequest('accept', requestId, 'Request accepted successfully.');
                        }
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-default',
                        callback: function () { }
                    }
                }
            });
        }

        /**
         * Ask user confirmation before rejecting an acknowledge request.
         * @param {number} requestId request identifier to reject
         */
        function confirmRejectAcknowledgeRequest(requestId) {
            bootbox.dialog({
                message: '<strong>You are about to reject this request. Are you sure?</strong><br/><br/>',
                title: 'Caution!',
                buttons: {
                    confirm: {
                        label: 'Confirm',
                        className: 'btn-danger',
                        callback: function () {
                            runActionRequest('reject', requestId, 'Request rejected successfully.');
                        }
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-default',
                        callback: function () { }
                    }
                }
            });
        }

        /**
         * Open flight date picker for request form.
         */
        function openJumpseatFlightDatePicker() {
            $scope.jumpseatRequestFormState.isFlightDatePickerOpen = true;
        }

        /**
         * Handle request type changes and keep form consistency.
         */
        function onJumpseatRequestTypeChanged() {
            if (isGeneralDeclarationType($scope.jumpseatRequestForm.RequestType)) {
                $scope.jumpseatRequestForm.TravelersType = null;
                $scope.jumpseatRequestForm.EntitledPassengers = [];
                return;
            }

            if (!$scope.jumpseatRequestForm.TravelersType) {
                $scope.jumpseatRequestForm.TravelersType = getDefaultTravelersTypeId();
            }

            onJumpseatTravelersTypeChanged();
        }

        /**
         * Handle travelers type changes and passenger rows.
         */
        function onJumpseatTravelersTypeChanged() {
            if (!$scope.jumpseatRequestForm.EntitledPassengers) {
                $scope.jumpseatRequestForm.EntitledPassengers = [];
            }

            if (!shouldShowEntitledPassengersSection()) {
                $scope.jumpseatRequestForm.EntitledPassengers = [];
                return;
            }

            if ($scope.jumpseatRequestForm.EntitledPassengers.length === 0) {
                addEntitledPassenger();
            }
        }

        /**
         * Return true when travelers controls should be shown.
         * @returns {boolean} true when request is not GD
         */
        function shouldShowTravelersSection() {
            return !isGeneralDeclarationType($scope.jumpseatRequestForm.RequestType);
        }

        /**
         * Return true when entitled persons list should be shown.
         * @returns {boolean} true when travelers type needs entitled persons
         */
        function shouldShowEntitledPassengersSection() {
            return shouldShowTravelersSection() &&
                ($scope.jumpseatRequestForm.TravelersType === 2 || $scope.jumpseatRequestForm.TravelersType === 3);
        }

        /**
         * Add one entitled person row to the request form.
         */
        function addEntitledPassenger() {
            $scope.jumpseatRequestForm.EntitledPassengers.push({
                Name: '',
                RelationshipId: getDefaultRelationshipId()
            });
        }

        /**
         * Remove one entitled person row from the request form.
         * @param {number} index row index to remove
         */
        function removeEntitledPassenger(index) {
            if (index >= 0 && index < $scope.jumpseatRequestForm.EntitledPassengers.length) {
                $scope.jumpseatRequestForm.EntitledPassengers.splice(index, 1);
            }

            if (shouldShowEntitledPassengersSection() && $scope.jumpseatRequestForm.EntitledPassengers.length === 0) {
                addEntitledPassenger();
            }
        }

        /**
         * Validate and submit jumpseat request form.
         */
        function submitJumpseatRequest() {
            var payload;

            if (!window.navigator.onLine) {
                bootbox.alert({ title: "<div class='text-orange'>No Internet</div>", message: 'Please check the internet connection!' });
                return;
            }

            payload = buildSubmitRequestPayload();
            if (!payload) {
                return;
            }

            $scope.isSubmittingJumpseatRequest = true;

            JumpseatRequestsFactory.submitRequest(payload, function (responseData) {
                $scope.isSubmittingJumpseatRequest = false;

                if (!responseData.success) {
                    bootbox.alert({
                        title: "<div class='text-red'>Error</div>",
                        message: responseData.errorMessage || 'Unable to submit jumpseat request.'
                    });
                    return;
                }

                bootbox.alert({
                    title: "<div class='text-green'>Success</div>",
                    message: 'Jumpseat request submitted successfully.',
                    callback: function () {
                        resetJumpseatRequestForm();
                        refreshJumpseatInfo();
                    }
                });
            }, function () {
                $scope.isSubmittingJumpseatRequest = false;
                bootbox.alert({ title: "<div class='text-red'>Error</div>", message: 'Unable to submit jumpseat request.' });
            });
        }

        /**
         * Initialize request form defaults.
         */
        function initializeJumpseatRequestForm() {
            var dateFrom = $scope.jumpseatInfo.DateFrom ? new Date($scope.jumpseatInfo.DateFrom) : null;
            var dateTo = $scope.jumpseatInfo.DateTo ? new Date($scope.jumpseatInfo.DateTo) : null;

            $scope.jumpseatFlightDateOptions = {
                minDate: dateFrom,
                maxDate: dateTo,
                initDate: dateFrom,
                startingDay: 1
            };

            if (!$scope.jumpseatRequestForm || !$scope.jumpseatRequestForm._initialized) {
                $scope.jumpseatRequestForm = {
                    _initialized: true,
                    RequestType: getDefaultRequestTypeId(),
                    FlightDate: null,
                    FlightNo: '',
                    Departure: '',
                    TravelersType: getDefaultTravelersTypeId(),
                    EntitledPassengers: []
                };
            }

            if (!$scope.jumpseatInfo.IsGDEligible) {
                $scope.jumpseatRequestForm.RequestType = getJumpseatRequestTypeId();
            }

            onJumpseatRequestTypeChanged();
        }

        /**
         * Reset jumpseat request form to its initial state.
         */
        function resetJumpseatRequestForm() {
            $scope.jumpseatRequestForm = {
                _initialized: false
            };
            $scope.jumpseatRequestFormState.isFlightDatePickerOpen = false;
        }

        /**
         * Build submit payload and validate required fields.
         * @returns {object|null} payload when valid, otherwise null
         */
        function buildSubmitRequestPayload() {
            var form = $scope.jumpseatRequestForm;
            var crewInfo = $scope.jumpseatInfo && $scope.jumpseatInfo.CrewInfo ? $scope.jumpseatInfo.CrewInfo : {};
            var passengers = [];
            var index;

            if (!form.FlightDate) {
                bootbox.alert({ title: "<div class='text-orange'>Validation</div>", message: 'Flight Date is required.' });
                return null;
            }

            if (!form.FlightNo || !form.FlightNo.trim()) {
                bootbox.alert({ title: "<div class='text-orange'>Validation</div>", message: 'Flight Number is required.' });
                return null;
            }

            if (!form.Departure || !form.Departure.trim()) {
                bootbox.alert({ title: "<div class='text-orange'>Validation</div>", message: 'Departure is required.' });
                return null;
            }

            if (shouldShowTravelersSection() && !form.TravelersType) {
                bootbox.alert({ title: "<div class='text-orange'>Validation</div>", message: 'Travelers Type is required.' });
                return null;
            }

            if (shouldShowEntitledPassengersSection()) {
                if (!form.EntitledPassengers || form.EntitledPassengers.length === 0) {
                    bootbox.alert({ title: "<div class='text-orange'>Validation</div>", message: 'At least one entitled person is required.' });
                    return null;
                }

                for (index = 0; index < form.EntitledPassengers.length; index += 1) {
                    if (!form.EntitledPassengers[index].Name || !form.EntitledPassengers[index].Name.trim()) {
                        bootbox.alert({ title: "<div class='text-orange'>Validation</div>", message: 'Entitled Person Name is required.' });
                        return null;
                    }

                    if (!form.EntitledPassengers[index].RelationshipId) {
                        bootbox.alert({ title: "<div class='text-orange'>Validation</div>", message: 'Relationship is required.' });
                        return null;
                    }

                    passengers.push({
                        Name: form.EntitledPassengers[index].Name.trim(),
                        Relationship: form.EntitledPassengers[index].RelationshipId
                    });
                }
            }

            return {
                RequestType: form.RequestType,
                FlightDate: moment(form.FlightDate).format('YYYY-MM-DDTHH:mm:ss[Z]'),
                FlightNo: form.FlightNo.trim().toUpperCase(),
                Departure: form.Departure.trim().toUpperCase(),
                RequestorId: $scope.currentUser.id,
                TravelersType: shouldShowTravelersSection() ? form.TravelersType : 1,
                Passengers: passengers
            };
        }


        /**
         * Execute one request action call and show success/error feedback.
         * @param {string} actionType action type: cancel|accept|reject
         * @param {number} requestId request identifier
         * @param {string} successMessage message shown on success
         */
        function runActionRequest(actionType, requestId, successMessage) {
            var actionCall = getActionCall(actionType);

            if (!window.navigator.onLine) {
                bootbox.alert({ title: "<div class='text-orange'>No Internet</div>", message: 'Please check the internet connection!' });
                return;
            }

            if (!actionCall) {
                bootbox.alert({ title: "<div class='text-red'>Error</div>", message: 'Invalid action request.' });
                return;
            }

            bootbox.dialog({
                closeButton: false,
                message: '<div class="text-center"><i class="fa fa-spin fa-spinner"></i> Please wait...</div>'
            });

            actionCall(requestId, function (responseData) {
                bootbox.hideAll();

                if (!responseData.success) {
                    bootbox.alert({
                        title: "<div class='text-red'>Error</div>",
                        message: responseData.errorMessage || 'Unable to complete jumpseat action.'
                    });
                    return;
                }

                bootbox.alert({
                    title: "<div class='text-green'>Success</div>",
                    message: successMessage,
                    callback: function () {
                        refreshJumpseatInfo();
                    }
                });
            }, function () {
                bootbox.hideAll();
                bootbox.alert({ title: "<div class='text-red'>Error</div>", message: 'Unable to complete jumpseat action.' });
            });
        }

        /**
         * Resolve proper service call function for action type.
         * @param {string} actionType action type value
         * @returns {function|null} action service function or null
         */
        function getActionCall(actionType) {
            if (actionType === 'cancel') {
                return JumpseatRequestsFactory.cancelRequest;
            }

            if (actionType === 'accept') {
                return JumpseatRequestsFactory.acceptRequest;
            }

            if (actionType === 'reject') {
                return JumpseatRequestsFactory.rejectRequest;
            }

            return null;
        }

        /**
         * Get default request type id according to eligibility.
         * @returns {number} request type id
         */
        function getDefaultRequestTypeId() {
            if (!$scope.jumpseatInfo.IsGDEligible) {
                return getJumpseatRequestTypeId();
            }

            return getJumpseatRequestTypeId();
        }

        /**
         * Get jumpseat request type id from ancillaries.
         * @returns {number} request type id for Jumpseat Request
         */
        function getJumpseatRequestTypeId() {
            var requestTypes = $scope.jumpseatInfo && $scope.jumpseatInfo.Ancillaries && $scope.jumpseatInfo.Ancillaries.RequestTypes
                ? $scope.jumpseatInfo.Ancillaries.RequestTypes
                : [];
            var index;

            for (index = 0; index < requestTypes.length; index += 1) {
                if ((requestTypes[index].text || '').toLowerCase().indexOf('jumpseat') !== -1) {
                    return requestTypes[index].id;
                }
            }

            return 1;
        }

        /**
         * Check whether request type corresponds to General Declaration.
         * @param {number} requestTypeId request type id value
         * @returns {boolean} true when request type is General Declaration
         */
        function isGeneralDeclarationType(requestTypeId) {
            var requestTypes = $scope.jumpseatInfo && $scope.jumpseatInfo.Ancillaries && $scope.jumpseatInfo.Ancillaries.RequestTypes
                ? $scope.jumpseatInfo.Ancillaries.RequestTypes
                : [];
            var index;

            for (index = 0; index < requestTypes.length; index += 1) {
                if (requestTypes[index].id === requestTypeId) {
                    return (requestTypes[index].text || '').toLowerCase().indexOf('general declaration') !== -1;
                }
            }

            return requestTypeId === 2;
        }

        /**
         * Get default travelers type id from ancillaries.
         * @returns {number} travelers type id
         */
        function getDefaultTravelersTypeId() {
            var travelersTypes = $scope.jumpseatInfo && $scope.jumpseatInfo.Ancillaries && $scope.jumpseatInfo.Ancillaries.TravelersTypes
                ? $scope.jumpseatInfo.Ancillaries.TravelersTypes
                : [];

            if (travelersTypes.length > 0) {
                return travelersTypes[0].id;
            }

            return 1;
        }

        /**
         * Get default relationship id from ancillaries.
         * @returns {number|null} relationship id
         */
        function getDefaultRelationshipId() {
            var relationships = $scope.jumpseatInfo && $scope.jumpseatInfo.Ancillaries && $scope.jumpseatInfo.Ancillaries.PassengerRelationships
                ? $scope.jumpseatInfo.Ancillaries.PassengerRelationships
                : [];

            if (relationships.length > 0) {
                return relationships[0].id;
            }

            return null;
        }


        /**
         * Resolve display label for a request status value.
         * @param {number} statusValue numeric status value
         * @returns {string} user-friendly status text
         */
        function getJumpseatStatusLabel(statusValue) {
            var statuses = $scope.jumpseatInfo && $scope.jumpseatInfo.Ancillaries
                ? $scope.jumpseatInfo.Ancillaries.Statuses
                : null;
            var index;

            if (statuses && statuses.length) {
                for (index = 0; index < statuses.length; index += 1) {
                    if (statuses[index].value === statusValue) {
                        return statuses[index].label;
                    }
                }
            }

            if (statusValue === 1) {
                return 'Pending';
            }

            if (statusValue === 2) {
                return 'Accepted';
            }

            if (statusValue === 3) {
                return 'Rejected';
            }

            return 'Unknown';
        }

        /**
         * Map status value to existing badge class.
         * @param {number} statusValue numeric status value
         * @returns {string} css badge class
         */
        function getJumpseatStatusBadgeClass(statusValue) {
            if (statusValue === 2) {
                return 'badge-green';
            }

            if (statusValue === 3) {
                return 'badge-danger';
            }

            return 'badge-primary';
        }

        /**
         * Check whether request type is General Declaration.
         * @param {number} requestType request type value
         * @returns {boolean} true when request type is GD
         */
        function isGeneralDeclarationRequest(requestType) {
            return requestType === 1;
        }

        /**
         * Check whether a request has passenger rows for rendering.
         * @param {object} request submitted request object
         * @returns {boolean} true when at least one passenger row exists
         */
        function hasSubmittedPassengerRows(request) {
            return request && request._submittedPassengerRows && request._submittedPassengerRows.length > 0;
        }

        /**
         * Return cached passenger rows for a submitted request.
         * @param {object} request submitted request object
         * @returns {array} prepared passenger rows for the UI
         */
        function getSubmittedPassengerRows(request) {
            if (request && request._submittedPassengerRows) {
                return request._submittedPassengerRows;
            }

            if (request) {
                request._submittedPassengerRows = buildSubmittedPassengerRows(request);
                return request._submittedPassengerRows;
            }

            return [];
        }

        /**
         * Prepare submitted requests view-model after data load.
         */
        function prepareSubmittedRequestsViewModel() {
            var requests = $scope.jumpseatInfo && $scope.jumpseatInfo.SubmittedRequests
                ? $scope.jumpseatInfo.SubmittedRequests
                : [];
            var index;

            for (index = 0; index < requests.length; index += 1) {
                requests[index]._submittedPassengerRows = buildSubmittedPassengerRows(requests[index]);
            }
        }

        /**
         * Build passenger rows according to TravelersType rules.
         * @param {object} request submitted request object
         * @returns {array} normalized passenger rows for rendering
         */
        function buildSubmittedPassengerRows(request) {
            var passengers = request && request.Passengers ? request.Passengers : [];
            var passengerRows = [];
            var crewName = $scope.jumpseatInfo && $scope.jumpseatInfo.CrewInfo
                ? $scope.jumpseatInfo.CrewInfo.Name
                : '';
            var index;

            //TODO: change travelers values from specific numbers to more explicit constants in the service and use them here for better readability
            if (!request || request.TravelersType === 1) {
                return passengerRows;
            }

            if (request.TravelersType === 2) {
                return passengers;
            }

            if (request.TravelersType === 3) {
                passengerRows.push({
                    Name: crewName,
                    Relationship: '',
                    IsSelf: true
                });

                for (index = 0; index < passengers.length; index += 1) {
                    if (passengers[index].Relationship === 'Self' || passengers[index].Name === crewName) {
                        continue;
                    }

                    passengerRows.push(passengers[index]);
                }
            }

            return passengerRows;
        }


    }
})();
